import { FormGroup } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-filtro-fecha',
  templateUrl: './filtro-fecha.component.html',
  styleUrls: ['./filtro-fecha.component.scss'],
})
export class FiltroFechaComponent implements OnInit {
  public mostrarCalendarioInicio = false;
  public mostrarCalendarioFinal = false;

  public calendarioSelected = -1;

  @Input() fechasForm: FormGroup;

  constructor() {}

  ngOnInit(): void {}

  public changeCalendarioSelected(calendario: number) {
    console.log(calendario)
    this.calendarioSelected =
      calendario === this.calendarioSelected ? -1 : calendario
  }

  public actualizarFechaInicio(fecha) {
    this.fechasForm.get('fechaInicio').setValue(fecha);
  }

  public actualizarFechaFin(fecha) {
    this.fechasForm.get('fechaFinal').setValue(fecha);
  }

  get fechaFinal() {
    return this.fechasForm.get('fechaFinal').value;
  }

  get fechaInicio() {
    return this.fechasForm.get('fechaInicio').value;
  }
}
